/*
 * @Description: c-table
 * @Author: yaoxiaoxiao
 * @Date: 2021-03-16 17:17:45
 * @LastEditors: yaoxiaoxiao
 * @LastEditTime: 2021-03-16 17:18:16
 */
import CTable from './index.vue'
export default CTable
